import React, { Component } from 'react';
import Grid from '@mui/material/Grid';
import Switch from '../../../components/Switch.js';
import NumberInput from '../../../components/TextFields/NumberInput.js';
import Text from '../../../components/Text.js';
import TextInput from '../../../components/TextFields/TextInput.js';
import { colors } from '../../../theme/index.js';
import Bubble from '../../../components/Bubble.js';
class FinancialAwareness extends Component {
  state = {
    data: null
  };
  componentDidMount() {
    const defaults = this._setData(this.props.data);

    // we are viewing a revision so we don't need to set data in state
    if (this.props.revision) {
      return;
    }
    if (this.props.type === "modular") {
      // save the init data in global state so it's there for the save
      this.props.saveModularBenefitInitData(this.props.classID, this.props.tier, 'financialAwareness', 'financialAwareness', defaults);
      return;
    }

    // save the init data in global state so it's there for the save
    this.props.savePlanDesignBenefitInitData(this.props.selectedClassID, this.props.selectedDesignID, 'financialAwareness', defaults);
  }
  componentDidUpdate(prevProps) {
    if (prevProps.data !== this.props.data) {
      const defaults = this._setData(this.props.data);

      // we are viewing a revision so we don't need to set data in state
      if (this.props.revision) {
        return;
      }
      if (this.props.type === "modular") {
        return;
      }
      if (this.props.selectedDesignID !== prevProps.selectedDesignID) {
        // save the init data in global state so it's there for the save
        this.props.savePlanDesignBenefitInitData(this.props.selectedClassID, this.props.selectedDesignID, 'financialAwareness', defaults);
      }
    }
  }
  _setData = data => {
    const defaults = {
      isSelected: data.isSelected || false,
      includeEnrichedAcademy: data.includeEnrichedAcademy === null || data.includeEnrichedAcademy === undefined ? true : data.includeEnrichedAcademy,
      terminationAge: typeof data.terminationAge === "number" ? data.terminationAge : 75,
      eligibilityPeriod: typeof data.eligibilityPeriod === "number" ? data.eligibilityPeriod : 3,
      minHoursPerWeek: typeof data.minHoursPerWeek === "number" ? data.minHoursPerWeek : 24,
      notes: data.notes || null
    };
    this.setState({
      data: {
        ...defaults
      }
    });
    return defaults;
  };
  _handleChange = (field, value) => {
    // we are viewing a revision so we don't need to set data in state
    if (this.props.revision) {
      return;
    }
    this.setState({
      data: {
        ...this.state.data,
        [field]: value
      }
    });
  };
  _saveInGlobalState = (field, value) => {
    // we are viewing a revision so we don't need to set data in state
    if (this.props.revision) {
      return;
    }
    if (field === 'notes' && value.toString().length === 0) {
      value = null;
    }
    if (this.props.type === "modular") {
      this.props.saveModularField(this.props.classID, this.props.tier, 'financialAwareness', 'financialAwareness', field, value);
    } else {
      this.props.savePlanDesignField(this.props.selectedClassID, this.props.selectedDesignID, 'financialAwareness', field, value);
    }
    this.props.setChangesMadeFlag();
  };
  render() {
    if (!this.state.data) {
      return null;
    }
    const {
      errors,
      whitelabel,
      revision,
      isRevisionBlock,
      lightTierColor,
      darkTierColor
    } = this.props;
    const data = this.state.data;
    const isSelected = Boolean(data.isSelected);
    const styles = {
      block: {
        border: "1.5px solid #F1F1F1",
        paddingLeft: 30,
        paddingRight: 30,
        borderRadius: 5,
        marginTop: 20,
        backgroundColor: isRevisionBlock ? '#F7F9FA' : '#FFFFFF'
      },
      header: {
        display: 'flex',
        flex: 1,
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: "space-between",
        borderBottom: isSelected ? "1.5px solid #F1F1F1" : null
      },
      headerBorder: {
        borderBottom: "1.5px solid #F1F1F1"
      },
      content: {
        paddingTop: 20,
        paddingBottom: 50
      },
      tierLabel: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: 90,
        padding: 5,
        marginRight: 10
      }
    };
    return /*#__PURE__*/React.createElement("div", {
      style: styles.block
    }, /*#__PURE__*/React.createElement("div", {
      style: styles.header
    }, /*#__PURE__*/React.createElement(Text, {
      large: true,
      bold: true,
      display: "block",
      margin: "20px 0",
      color: whitelabel.primaryColor || colors.skyBlue
    }, revision ? isRevisionBlock ? `Financial Awareness (${revision.revisionID})` : `Financial Awareness (Current)` : 'Financial Awareness'), /*#__PURE__*/React.createElement("div", {
      style: {
        display: 'flex',
        justifyContent: 'flex-end',
        flexDirection: 'row',
        flex: 1
      }
    }, this.props.tier && /*#__PURE__*/React.createElement("div", {
      style: {
        ...styles.tierLabel,
        backgroundColor: lightTierColor
      }
    }, /*#__PURE__*/React.createElement(Text, {
      bold: true,
      medium: true,
      color: darkTierColor
    }, this.props.tier.toUpperCase())), /*#__PURE__*/React.createElement(Switch, {
      checked: data.isSelected,
      onChange: () => this._saveInGlobalState("isSelected", !isSelected)
    }))), Boolean(data.isSelected) && /*#__PURE__*/React.createElement("div", {
      style: styles.content
    }, /*#__PURE__*/React.createElement(Text, {
      small: true,
      margin: "0 0 20px 0"
    }, "Financial Awareness is a program that aims to improve health & well-being by reducing financial stress."), /*#__PURE__*/React.createElement(Grid, {
      container: true,
      direction: "row",
      alignItems: "center",
      spacing: 2
    }, /*#__PURE__*/React.createElement(Bubble, {
      label: 'Enriched Academy',
      isSelected: data.includeEnrichedAcademy === null || data.includeEnrichedAcademy === undefined ? true : data.includeEnrichedAcademy,
      onClick: (field, value) => this._saveInGlobalState(field, value)
    })), /*#__PURE__*/React.createElement(Text, {
      mediumLarge: true,
      bold: true,
      margin: "20px 0 10px 0"
    }, "Plan Eligibility & Termination"), /*#__PURE__*/React.createElement(Text, {
      small: true
    }, "Please complete the following:"), /*#__PURE__*/React.createElement(Grid, {
      container: true,
      direction: "row",
      alignItems: "center",
      spacing: 2
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 6,
      sm: 4
    }, /*#__PURE__*/React.createElement(NumberInput, {
      label: "Eligibility Period (Months)",
      fullWidth: true,
      value: data.eligibilityPeriod,
      variant: "outlined",
      onChange: e => this._handleChange("eligibilityPeriod", e.target.value),
      onBlur: e => this._saveInGlobalState("eligibilityPeriod", e.target.value),
      error: errors.eligibilityPeriod
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 6,
      sm: 4
    }, /*#__PURE__*/React.createElement(NumberInput, {
      label: "Minimum Hours per Week",
      fullWidth: true,
      value: data.minHoursPerWeek,
      variant: "outlined",
      onChange: e => this._handleChange("minHoursPerWeek", e.target.value),
      onBlur: e => this._saveInGlobalState("minHoursPerWeek", e.target.value),
      error: errors.minHoursPerWeek
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 6,
      sm: 4
    }, /*#__PURE__*/React.createElement(NumberInput, {
      label: "Termination Age",
      fullWidth: true,
      value: data.terminationAge,
      onChange: e => this._handleChange("terminationAge", e.target.value),
      onBlur: e => this._saveInGlobalState("terminationAge", e.target.value),
      error: errors.terminationAge,
      variant: "outlined"
    }))), /*#__PURE__*/React.createElement(Text, {
      small: true,
      bold: true
    }, "Notes:"), /*#__PURE__*/React.createElement(TextInput, {
      fullWidth: true,
      value: data.notes || '',
      variant: "outlined",
      error: errors.notes,
      onChange: e => this._handleChange("notes", e.target.value),
      onBlur: e => this._saveInGlobalState("notes", e.target.value),
      multiline: true,
      rows: 5,
      placeholder: "Please add any additional requests or information for your provider. All information is confidential and will only be used to complete pricing."
    })));
  }
}
export default FinancialAwareness;